module.exports = __webpack_public_path__ + "static/media/UE-EN-Top-white.7eadc6e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UE-EN-Top-white.svg
// module id = 240
// module chunks = 0